import domContentLoaded from "dom-content-loaded";
import { throttle } from "throttle-debounce";

export default () => {
  let lastInnerWidth;
  domContentLoaded(() => {
    const { body } = document;
    const navTriggers = document.querySelectorAll(
      ".js_menu_trigger,.js_menu_cover"
    );
    const navContents = document.querySelector(".js_menu");
    let sc;
    navTriggers.forEach((navTrigger) => {
      navTrigger.addEventListener("click", () => {
        lastInnerWidth = window.innerWidth;
        const flag = navContents.classList.contains("is_opened");
        if (flag) {
          body.classList.remove("is_locked");
          window.scrollTo(0, sc);
          body.style.top = "";
          navContents.classList.remove("is_opened");
          navContents.classList.add("is_closed");
          for (let i = 0; i < navTriggers.length; i += 1) {
            const trigger = navTriggers[i];
            trigger.classList.remove("is_opened");
            trigger.classList.add("is_closed");
          }
        } else {
          sc = Math.trunc(window.pageYOffset);
          body.style.top = `${sc * -1}px`;
          body.classList.add("is_locked");
          navContents.classList.remove("is_closed");
          navContents.classList.add("is_opened");
          for (let i = 0; i < navTriggers.length; i += 1) {
            const trigger = navTriggers[i];
            trigger.classList.remove("is_closed");
            trigger.classList.add("is_opened");
          }
        }
      });
    });
    // メニュー内のページ内リンクをクリックするとリロードして移動します。
    const anchorlinks = document.querySelectorAll(
      ".bl_sitemap__menu .js_menu_anchorlink"
    );
    anchorlinks.forEach((anchorlink) => {
      anchorlink.addEventListener("click", (e) => {
        const anchorlinkUrl = e.target.href.split("#");
        if (anchorlinkUrl[0] === location.href.split("#")[0]) {
          window.location.href = `.//#${anchorlinkUrl[1]}`;
        }
      });
    });
  });
  window.addEventListener(
    "resize",
    throttle(200, () => {
      if (
        lastInnerWidth !== window.innerWidth &&
        window.innerWidth >= 768 &&
        document.body.classList.contains("is_locked")
      ) {
        document.body.classList.remove("is_locked");
        window.scrollTo(0, 0);
        document.body.style.top = "";
        document.querySelector(".js_menu").classList.remove("is_opened");
        document.querySelector(".js_menu").classList.add("is_closed");
        document
          .querySelectorAll(".js_menu_trigger,.js_menu_cover")
          .forEach((navTrigger) => {
            navTrigger.classList.remove("is_opened");
            navTrigger.classList.add("is_closed");
          });
      }
    }),
    false
  );
};
